import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  getProcInitWizardList,
  ProcInitWizard,
} from '../../../services/workflow';

const ListOfTasks = (props: SelectProps<any>) => {
  const { data } = useQuery('getProcInitWizardList', () =>
    getProcInitWizardList().then((res) => res.list || [])
  );

  return (
    <Select {...props}>
      {data?.map((task: ProcInitWizard) => (
        <Select.Option value={task.taskid} key={task.taskid}>
          {task.tasklabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ListOfTasks;
